<template>
  <div>
    <Head title="Gebruikers" />
    <h1 class="mb-8 text-3xl font-bold">{{ users.total }} Gebruikers</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter
        v-model="form.search"
        class="mr-4 w-full max-w-md"
        @reset="reset"
      >
        <label class="block text-gray-700">Wijk:</label>
        <select v-model="form.municipality" class="form-select mt-1 w-full">
          <option :value="null">Alle</option>
          <option
            v-for="municipality in municipalities"
            :value="municipality.id"
            :key="municipality.id"
          >
            {{ municipality.name }}
          </option>
        </select>
      </search-filter>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th
            class="pb-4 pt-6 px-6 cursor-pointer"
            @click="toggleOrder('deleted_at')"
          >
            Actief
          </th>
          <th
            class="pb-4 pt-6 px-6 cursor-pointer"
            @click="toggleOrder('first_name')"
          >
            Gebruiker
          </th>
          <th
            class="pb-4 pt-6 px-6 cursor-pointer"
            @click="toggleOrder('created_at')"
          >
            Geregistreerd
          </th>
          <th
            class="pb-4 pt-6 px-6 cursor-pointer"
            @click="toggleOrder('ambassador')"
          >
            Ambassadeur
          </th>
          <!-- <th
            class="pb-4 pt-6 px-6 cursor-pointer"
            @click="toggleOrder('public_point')"
          >
            Boekenbuurpunt
          </th> -->
          <!-- <th
            class="pb-4 pt-6 px-6 cursor-pointer"
            @click="toggleOrder('public_request')"
          >
            Openbaar
          </th> -->
          <th
            class="pb-4 pt-6 px-6 cursor-pointer"
            @click="toggleOrder('street.municipality.name')"
          >
            Wijk
          </th>
          <th
            class="pb-4 pt-6 px-6 cursor-pointer"
            @click="toggleOrder('active_loans_count')"
          >
            Uitgeleend
          </th>
          <th class="pb-4 pt-6 px-6"></th>
        </tr>
        <tr
          v-for="userItem in users.data"
          :key="userItem.data.id"
          class="hover:bg-gray-100 focus-within:bg-gray-100"
        >
          <td class="border-t">
            <Link
              class="flex items-center px-6 py-4"
              :href="`/users/${userItem.data.id}?activeTab=loans`"
              tabindex="-1"
            >
              {{ userItem.data.active ? "&#10003;" : "" }}
            </Link>
          </td>

          <td class="border-t">
            <Link
              class="flex items-center px-6 py-4 focus:text-indigo-500"
              :href="`/users/${userItem.data.id}?activeTab=loans`"
            >
              <img
                v-if="userItem.data.avatar"
                :src="userItem.data.avatar"
                :alt="userItem.data.name"
                class="rounded-full h-8 w-8 object-cover"
              />

              <span class="pl-2">{{ userItem.data.name }}</span>
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-6 py-4"
              :href="`/users/${userItem.data.id}?activeTab=loans`"
              tabindex="-1"
            >
              {{ userItem.data.created_at }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-6 py-4"
              :href="`/users/${userItem.data.id}?activeTab=loans`"
              tabindex="-1"
            >
              {{ userItem.data.ambassador ? "&#10003;" : "" }}
            </Link>
          </td>

          <!-- <td class="border-t">
            <Link
              class="flex items-center px-6 py-4"
              :href="`/users/${userItem.data.id}?activeTab=loans`"
              tabindex="-1"
            >
              {{ userItem.data.public_point ? "&#10003;" : "" }}
            </Link>
          </td> -->

          <!-- <td class="border-t">
            <Link
              class="flex items-center px-6 py-4"
              :href="`/users/${userItem.data.id}?activeTab=loans`"
              tabindex="-1"
            >
              {{ userItem.data.public_request }}
            </Link>
          </td> -->
          <!-- <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/users/${userItem.data.id}?activeTab=loans`" tabindex="-1">
                {{ userItem.data.email }}
            </Link>
          </td>           -->
          <td class="border-t">
            <Link
              class="flex items-center px-6 py-4"
              :href="`/users/${userItem.data.id}?activeTab=loans`"
              tabindex="-1"
            >
              {{ userItem.data.street.data.municipality.data.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-6 py-4"
              :href="`/users/${userItem.data.id}?activeTab=loans`"
              tabindex="-1"
            >
              {{ userItem.data.active_loans_count || "" }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link
              class="flex items-center px-4"
              :href="`/users/${userItem.data.id}?activeTab=loans`"
              tabindex="-1"
            >
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="users.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">
            Geen gebruikers gevonden.
          </td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="users.links" />
  </div>
</template>

<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import Icon from "@/Shared/Icon";
import pickBy from "lodash/pickBy";
import Layout from "@/Shared/Layout";
import throttle from "lodash/throttle";
import mapValues from "lodash/mapValues";
import Pagination from "@/Shared/Pagination";
import SearchFilter from "@/Shared/SearchFilter";
import Multiselect from "@vueform/multiselect";

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    Multiselect,
  },
  layout: Layout,
  props: {
    filters: Object,
    users: Object,
    municipalities: Array,
    order: String,
    direction: String,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        order: this.order,
        direction: this.direction,
      },
    };
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get("/users", pickBy(this.form), { preserveState: true });
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null);
    },
    toggleOrder(field) {
      if (this.form.order != field) {
        this.form.direction = "desc";
      } else {
        this.form.direction = this.form.direction === "asc" ? "desc" : "asc";
      }

      this.form.order = field;
    },
  },
};
</script>

